import axios from 'axios'
import * as Config from '../../config'

const actions = {

    load_Series({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath +"/"+ 'serie/all')
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    // load_CountriesActivated({ commit, dispatch }) {
    //     return new Promise((resolve, reject) => {

    //         axios.get(Config.apiPath + 'country/activated/list/all')
    //             .then(
    //                 response => {
    //                     //commit('LOAD_CATEGORIES',response.data)
    //                     resolve(response.data);

    //                 })
    //             .catch(error => {
    //                 reject(error.response.data);
    //             });
    //     });
    // },
    // load_Category({ commit, dispatch }, form) {
    //     return new Promise((resolve, reject) => {
    //         axios.get(Config.apiPath + 'country/consult/' + form.id)
    //             .then(
    //                 response => {
    //                     //commit('LOAD_CATEGORY', data);
    //                     resolve(response.data);

    //                 })
    //             .catch(error => {
    //                 reject(error.response.data);
    //             });
    //     });

    // },
    // new_Category({ commit, dispatch }, form) {

    //     return new Promise((resolve, reject) => {
    //         axios.post(Config.apiPath + 'country/store', form)
    //             .then(
    //                 response => {
    //                     resolve(response.data);
    //                 })
    //             .catch(error => {
    //                 reject(error.response.data);
    //             });
    //     });
    // },
    // changeActive_Category({ commit, dispatch }, form) {

    //     return new Promise((resolve, reject) => {
    //         axios.put(Config.apiPath + 'country/change/active/' + form.id + '/' + form.active)
    //             .then(response => {
    //                 resolve(response.data);
    //             })
    //             .catch(error => {
    //                 reject(error.response.data);
    //             });
    //     });
    // },
    // changeStatus_Category({ commit, dispatch }, form) {

    //     return new Promise((resolve, reject) => {
    //         axios.put(Config.apiPath + 'country/change/status/' + form.id + '/' + form.status)
    //             .then(response => {
    //                 resolve(response.data);
    //             })
    //             .catch(error => {
    //                 reject(error.response.data);
    //             });
    //     });
    // },
    // update_Category({ commit, dispatch }, form) {

    //     return new Promise((resolve, reject) => {
    //         axios.put(Config.apiPath + 'country/update/' + form.id, form)
    //             .then(
    //                 response => {
    //                     resolve(response.data);
    //                 })
    //             .catch(error => {
    //                 reject(error.response.data);
    //             });
    //     });
    // },
    // delete_Category({ commit, dispatch }, form) {
    //     return new Promise((resolve, reject) => {
    //         axios.put(Config.apiPath + 'country/change/active/' + form.id + '/' + form.active)
    //             .then(
    //                 response => {
    //                     resolve(response.data);
    //                 })
    //             .catch(error => {
    //                 reject(error.response.data);
    //             });
    //     });
    // },
}

const mutations = {

}

export default {
    actions,
    mutations
}